import {Component, OnInit} from '@angular/core';
import {CompanyDTO} from '../../../services/api/api';
import {UtilService} from '../../../services/util.service';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'page-client-overview',
  templateUrl: './client-overview.component.html',
  styleUrls: ['./client-overview.component.scss'],
  standalone: false,
})
export class ClientOverviewComponent implements OnInit {
  company: CompanyDTO;

  constructor(
    public util: UtilService,
    public userService: UserService
  ) {
    this.company = this.userService.user.client.primaryCompany;
  }

  ngOnInit() {}

  getSelectedCompanyCoords() {
    if (this.company && this.company.address && this.company.address.position) {
      return { x: this.company.address.position.coordinates[0], y: this.company.address.position.coordinates[1] };
    }
  }
}
